module.exports = __webpack_public_path__ + "img/2-2.5af4222c.jpg";